import * as React from "react";
import { ContentTypeEnum } from "../../common/api/searchApi.types";
import { useSearchContent } from "../../common/redux/searchContent";
import { IResultProps } from "./search-result.types";

const SearchResult: React.FC<IResultProps> = ({ result, onClick }) => {
  const searchContent = useSearchContent();

  const hitOnClick = () => onClick(result.hitId);

  const renderAuthors = () => {
    let authorText = "";

    if (!result.authors || result.authors.length === 0) return authorText;

    if (result.date && result.date.length > 0) authorText += ` | `;

    authorText += result.authors.join(", ");
    return authorText;
  };

  const hasImage = (): boolean =>
    Boolean(result.imageUrl && result.imageUrl.length > 0);

  const imageUrl = (): string =>
    `${
      hasImage() ? result.imageUrl : searchContent.thumbnailPlaceholder
    }?height=200&crop=0,0,200,200`;

  return (
    <div
      className={
        result.contentType !== ContentTypeEnum.Default
          ? "results-image-card"
          : "results-text-card"
      }
    >
      {result.contentType !== ContentTypeEnum.Default && (
        <a href={result.url} onClick={hitOnClick}>
          <div className="float-md-left float-right results-image-container">
            <div
              className={`results-mask--${ContentTypeEnum[
                result.contentType
              ].toLowerCase()}`}
            />
            <img
              className="results-type-image"
              src={imageUrl()}
              alt={result.imageAltText}
            />
          </div>
        </a>
      )}
      <div className="results-text-container">
        {result.contentType !== ContentTypeEnum.Default && (
          <h2
            className={`results-type-heading text-uppercase svg__span--${ContentTypeEnum[
              result.contentType
            ].toLowerCase()}`}
          >
            {result.contentTypeText}
          </h2>
        )}
        <a className="image-card-link" href={result.url} onClick={hitOnClick}>
          <h3
            className="results-type-subheading text-underline"
            dangerouslySetInnerHTML={{ __html: result.title }}
          />
        </a>
        {((result.date && result.date.length > 0) ||
          (result.authors && result.authors.length > 0)) && (
          <p className="results-type-date">
            {result.date}
            {renderAuthors()}
          </p>
        )}
        {result.description && (
          <p
            className="results-type-text"
            dangerouslySetInnerHTML={{ __html: result.description }}
          />
        )}
      </div>
    </div>
  );
};

export default SearchResult;
